import type StorageType from "#/types/legacyStorageTypes";
import type { IUser } from "#/types/user";
import { generateCache } from "#/utils/legacyData/cache/generateHelper";
import { emptyCache } from "#/utils/legacyData/localStorageData";
import type { TUtils } from "@monta/utils";

const getCacheInfoKey = (userId: string): string => {
  const cachePrefixName = "b-";
  return cachePrefixName + userId;
};

const loadLegacyStorage = (userId: number): StorageType | null => {
  if (typeof window !== "undefined") {
    let key = "";
    const keys: Array<string> = Object.keys(localStorage).filter(
      (item) => item.indexOf("b-") !== -1
    );
    if (!keys?.length) {
      return emptyCache;
    }

    if (userId) {
      key = keys.filter((key) => key.indexOf(userId?.toString()) !== -1)[0];
    }
    const montaStorageItems = localStorage.getItem(key)?.split("@@")[1];
    if (!montaStorageItems) {
      return null;
    }
    return JSON.parse(montaStorageItems);
  } else {
    return emptyCache;
  }
};

const removeLocalStorage = (): void => {
  const keys: Array<string> = Object.keys(localStorage).filter(
    (item) => item.indexOf("b-") !== -1
  );
  keys.forEach((key) => {
    localStorage.removeItem(key);
  });
};

const setBookInfos = (userId: number, api: TUtils["api"]): void => {
  removeLocalStorage();
  api.post("/user/getBookInfos/").then((response) => {
    if (response?.data) {
      const dataFormatMontaLocalStorage = new Date()
        .getTime()
        .toString()
        .concat("@@", JSON.stringify(response.data));
      localStorage.setItem(
        getCacheInfoKey(userId?.toString()),
        dataFormatMontaLocalStorage
      );
      generateCache(loadLegacyStorage(userId) as StorageType);
    }
  });
};

export const generateLocalStorage = (api: TUtils["api"]): void => {
  let user: IUser | undefined = undefined;

  try {
    const localStorageUser = localStorage.getItem("user");
    if (localStorageUser) {
      user = JSON.parse(localStorageUser);
    }
  } catch (error) {
    console.error(error);
  }

  if (!user) {
    return;
  }

  const { id, changeDate } = user;
  if (!id) return;
  const cacheInfoItem = localStorage.getItem(getCacheInfoKey(id?.toString()));
  if (cacheInfoItem) {
    const storageString = cacheInfoItem.trim().split("@@");
    if (storageString.length == 1) {
      setBookInfos(id, api);
    } else if (parseInt(storageString[0]) < changeDate) {
      setBookInfos(id, api);
    } else {
      const cacheData = loadLegacyStorage(id);
      generateCache(cacheData as StorageType);
    }
  } else {
    setBookInfos(id, api);
  }
};
